import PeriodSelector from "components/PeriodSelector";
import ExportButton from "design/components/buttons/ExportButton";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { t } from "i18next";

const useStyles = makeThemedStyles("ToolbarWithButton", (theme) => ({
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  exportButton: {
    marginTop: "-4px",
  },
}));

const ToolbarWithButton = (
  props: React.PropsWithChildren<{
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  }>
) => {
  const { onClick } = props;
  const classes = useStyles();

  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>{props.children}</ToolbarTitle>
        <Right>
          <div className={classes.rightSide}>
            <PeriodSelector />
            <div className={classes.exportButton}>
              <ExportButton onClick={onClick} title={t("Export Dashboard")} />
            </div>
          </div>
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ToolbarWithButton;
